import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';

const decode = (status: number, data: ResponseType): void => {
    if (status === 200 || status === 201) {
        return;
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

interface IsonisDataType {
    data: {
        from: Date,
        to: Date
    },
}

export const putIsonis = {
    browser: {
        params: (params: IsonisDataType): ParamsFetchType<IsonisDataType> => {
            return {
                type: MethodType.PUT,
                url: '/api-web/isonis',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.PUT,
        urlBrowser: '/api-web/isonis',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<IsonisDataType>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }

        return {
            url: `${params.API_URL}/isonis-reporter/report/star-doppler/isonis-report`,
            passToBackend: true,
            headers: {
                'X-Client-Req-Id': `${params.userSessionId}`
            },
            method: MethodType.PUT,
            body: params.req.body.data
        };
    }
};
